module.exports = __webpack_public_path__ + "31b4795d7fb4eccf35ab0f3079130fda.png";